var _path, _path2, _path3, _path4, _g, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2649_39134",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0032 26.6684H15.7857C9.99422 26.5528 5.33792 21.8217 5.33792 16.0031C5.33792 10.1844 9.99422 5.45332 15.7857 5.33776H16.0032H16.2208C21.9443 5.45332 26.553 10.062 26.6685 15.7855V16.0031V16.2206C26.553 22.0121 21.8287 26.6684 16.0032 26.6684ZM15.9964 29.333H16.2276C23.4057 29.2107 29.2108 23.4192 29.3332 16.2342V15.9963V15.7652C29.2108 8.58699 23.4125 2.78869 16.2276 2.66634H15.9897H15.7585C8.49878 2.78869 2.6665 8.70932 2.6665 15.9963C2.6665 23.2832 8.62795 29.3262 15.9897 29.3262L15.9964 29.333Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2649_39134)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2649_39134",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -501,
    y: -246,
    width: 871,
    height: 545
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M369.719 298.65H-500.363V-245.151H369.719V298.65Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2649_39134)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2649_39134",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: -3,
    width: 38,
    height: 38
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6012 34.9062H-2.78516V-2.48011H34.6012V34.9062Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2649_39134)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2649_39134",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 28,
    height: 28
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8429 29.4678H2.65283V2.27769H29.8429V29.4678Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2649_39134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2058 35.1982H-3.19336V-3.20095H35.2058V35.1982Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6735 37.666H-5.66748V-5.67493H37.6735V37.666Z",
    fill: "white"
  })))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4852 22.665H14.5215L14.9158 14.7663H17.023L17.4852 22.665Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9894 13.2842H15.8738C14.8406 13.223 14.0249 12.3461 14.0249 11.2993C14.0249 10.2525 14.8338 9.40281 15.8738 9.34163H15.9894H16.1049C17.1246 9.40281 17.9131 10.2049 17.9675 11.1838V11.2993V11.4149C17.9063 12.4549 17.0566 13.2842 15.9826 13.2842H15.9894Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCircle);
export default __webpack_public_path__ + "static/media/information-circle.952a564efe12fba3a49fbdebd56d5163.svg";
export { ForwardRef as ReactComponent };